import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/Dashboard/app/components/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/Dashboard/app/components/NavbarHorizontal.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/Dashboard/app/ToastContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/Dashboard/context/index.js");
;
import(/* webpackMode: "eager" */ "/root/mrbuttonv1/Dashboard/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/root/mrbuttonv1/Dashboard/app/globals.css");
